import React from 'react';
import logo from 'assets/img/icons/logo.png';
import logo_coroa from 'assets/img/icons/coroafull.gif';
import classNames from 'classnames';

interface LogoProps {
  width?: number;
  text?: boolean;
  textClass?: string;
  className?: string;
}

const Logo = ({ width = 27, text = true, textClass, className }: LogoProps) => {
  return (
    <div className={classNames(className, 'd-flex align-items-center')}>
      <img src={logo_coroa} alt="phoenix" width={width} />
      {text && (
        <p className={classNames(textClass, 'logo-text ms-2')}>Loja dos Noivos</p>
      )}
    </div>
  );
};

export default Logo;
